<template>
  <div style="position: fixed;top: 0;left: 0;width: 100vw;height: 100vh;">
    <van-row type="flex" style="margin-top: 30%" justify="center">
      <van-col span="20">
        <span style="height: 40px;line-height: 40px;font-size: 30px;font-weight: 700;color: #16253E;">
          绩效考核系统
          <img id="rocketIcon" style="position: relative;top: 5px;height: 35px;width: 35px;"
            src="../../assets/rocket.png">
        </span>
      </van-col>
      <van-col span="21" style="margin: 15px 0px">
        <van-form validate-first ref="form">
          <van-field style="background-color: #F4F5F9;" label-width="40px" v-model="form.account" label="账号 : "
            name="account" :rules="[{ required: true, message: '请输入账号' }]" maxlength="20"></van-field>
          <van-field style="background-color: #F4F5F9;" label-width="40px" v-model="form.password" label="密码 : "
            name="password" type="password" :rules="[{ required: true, message: '请输入密码' }]" maxlength="18">
          </van-field>
          <div style="display: flex;flex-direction: row;justify-content: center;margin: 10px 0px;">
            <van-col span="15">
              <van-field style="background-color: #F4F5F9;" label-width="50px" v-model="form.captcha" label="验证码 :"
                name="captcha" :rules="[{ required: true, message: '请输入验证码' }]"></van-field>
            </van-col>
            <van-col span="12">
              <van-image :src="src" @click="getCaptcha">
                <template v-slot:loading>
                  <van-loading type="spinner" size="20"></van-loading>
                </template>
                <template v-slot:error></template>
              </van-image>
            </van-col>
          </div>

          <van-checkbox style="margin-left: 15px;" v-model="checked" @change="handleLoginInfo">记住账号密码</van-checkbox>

        </van-form>
      </van-col>
    </van-row>
    <van-row type="flex" justify="center" style="height: 40px;margin-top: 15px;">
      <van-col span="15">
        <van-button id="login_btn" @click="submit" :loading="submitLoading" replace>登录</van-button>
      </van-col>
    </van-row>
  </div>
</template>

<script>
import Vue from 'vue';
import { Form, Field, Image as VanImage, Loading, Col, Row, Notify, Button, Checkbox, CheckboxGroup } from 'vant'
Vue.use(Form)
Vue.use(Field)
Vue.use(VanImage);
Vue.use(Loading);
Vue.use(Notify);
Vue.use(Col);
Vue.use(Row);
Vue.use(Button);
Vue.use(Checkbox);
Vue.use(CheckboxGroup);

export default {
  name: "login",
  data () {
    return {
      form: {
        account: '',
        password: '',
        key: '',
        captcha: ''
      },
      src: '',
      initialPage: '',
      submitLoading: false,
      difference: '',
      checked: false,
    }
  },

  mounted () {
    window.localStorage.removeItem("vuex");
    this.getURLSearchParams()
    this.getCaptcha();
    this.handleCheckRemember();
  },

  methods: {

    handleLoginInfo () {

      if (!this.checked) {
        window.localStorage.removeItem('account')
        window.localStorage.removeItem('password')
        window.localStorage.removeItem('remember')
      }
    },

    // 检查是否记住密码
    handleCheckRemember () {
      const remember = window.localStorage.getItem('remember');
      if (remember === null) {
        this.checked = false;
        this.form.account = '';
        this.form.password = '';
      } else {
        this.checked = true;
        this.form.account = window.localStorage.getItem('account');
        this.form.password = window.localStorage.getItem('password');
      }
    },

    // 获取地址栏code
    getURLSearchParams () {
      // 获取查询字符串（不包括哈希部分）  
      const search = window.location.search;
      // 创建一个新的 URLSearchParams 对象  
      const params = new URLSearchParams(search);
      // 获取 code 参数的值  
      this.difference = params.get('code');
    },

    getCaptcha () {
      this.$axios.get("/users/captcha").then((res) => {
        if (res.data.code === 200) {
          if (res.data.data !== null) {
            this.src = res.data.data.img;
            this.form.key = res.data.data.key;
          }
        }
        else {
          Notify({
            background: "#C70541",
            color: "#FFF",
            message: res.data.msg
          });
        }
      }).catch(() => {
        Notify({
          background: "#C70541",
          color: "#FFF",
          message: '获取验证码失败'
        });
      })
    },

    submit () {
      this.$refs.form.validate().then(() => {
        this.submitLoading = true;
        const params = {
          account: this.difference + '_' + this.form.account,
          password: this.form.password,
          key: this.form.key,
          captcha: this.form.captcha
        }

        if (this.checked) {
          window.localStorage.setItem('remember', this.checked)
          window.localStorage.setItem('account', this.form.account)
          window.localStorage.setItem('password', this.form.password)
        } else {
          window.localStorage.removeItem('account')
          window.localStorage.removeItem('password')
          window.localStorage.removeItem('remember')
        }

        // let submit_form = JSON.parse(JSON.stringify(this.form));
        let submit_form = JSON.parse(JSON.stringify(params));
        this.$axios.post("/users/login", submit_form).then((res) => {
          if (res.data.code === 200) {
            this.$store.commit('setToken', res.data.data); //获取token
            window.localStorage.setItem("token", res.data.data); //先手动存储token到localstorage
            this.$axios.get("/users/currentUser?token=" + this.$store.state.token).then((res) => { //利用token查询个人信息
              if (res.data.code === 200) {
                this.$store.commit('setUserInfo', res.data.data);
                let r1 = new Promise((resolve, reject) => {
                  /*******************根据角色id获得系统的用户的系统权限****************************/
                  this.$axios.get(`/roles/getByUserIdAndType?type=1`).then((res) => {//
                    if (res.data.code === 200) {
                      window.sessionStorage.setItem('userMenu', JSON.stringify(res.data.data))
                      this.initialPage = res.data.data[0].sys_power_id
                      console.log(this.initialPage, '当前要跳转的页面');
                      resolve();
                    }
                    else {
                      Notify({ background: "#C70541", color: "#FFF", message: '获取系统权限失败！' });
                      this.submitLoading = false
                      reject();
                    }
                  }).catch((err) => {
                    if (err.response.status === 500) {
                      Notify({ background: "#C70541", color: "#FFF", message: '网络异常，请检查网络后重试！' });
                    } else {
                      Notify({ background: "#C70541", color: "#FFF", message: '系统繁忙，请稍后重试！' });
                    }
                    this.submitLoading = false
                    reject();
                  })
                  /********************************************/
                })
                let r2 = new Promise((resolve, reject) => {
                  /**获得用户的所有角色 */
                  this.$axios.get("/users/getUserRoles?user_id=" + this.$store.state.userInfo.id).then((res) => {
                    if (res.data.code == 200) {
                      this.$store.commit('setRoles', res.data.data);
                      resolve();
                    }
                    else {
                      Notify({ background: "#C70541", color: "#FFF", message: '获取所有角色失败！' });
                      this.submitLoading = false;
                      reject();
                    }
                  }).catch((err) => {
                    if (err.response.status === 500) {
                      Notify({ background: "#C70541", color: "#FFF", message: '网络异常，请检查网络后重试！' });
                    } else {
                      Notify({ background: "#C70541", color: "#FFF", message: '系统繁忙，请稍后重试！' });
                    }
                    this.submitLoading = false
                    reject();
                  })
                  /********************************************/
                })
                let r3 = new Promise((resolve, reject) => {
                  this.$axios.get("/roles/getRoleById?id=" + this.$store.state.userInfo.rid).then((res) => {//根据登录的默认角色登录系统
                    if (res.data.code === 200) {
                      this.$store.commit('setRole', res.data.data);
                      resolve();
                    }
                    else {
                      reject();
                    }
                  }).catch(() => {
                    reject();
                  })
                })
                Promise.all([r1, r2, r3]).then(() => {
                  // this.$router.replace({ path: "/home" });
                  if (this.initialPage == '3') this.$router.replace({ path: "/audit" });
                  if (this.initialPage == '4') this.$router.replace({ path: "/reward" });
                  if (this.initialPage == '5') this.$router.replace({ path: "/report" });
                  window.localStorage.removeItem("token"); //登录后清除手动存储的token
                  Notify({ type: "success", message: '登录成功！' });
                  this.submitLoading = false;
                }).catch(() => {
                  this.$message.error("信息获取失败！");
                  this.submitLoading = false
                })
              }
              else {
                Notify({ background: "#C70541", color: "#FFF", message: '系统繁忙，请稍后重试！' });
                this.submitLoading = false
              }
            }).catch((err) => {
              if (err.response.status === 500) {
                Notify({ background: "#C70541", color: "#FFF", message: '网络异常，请检查网络后重试！' });
              }
              else {
                Notify({ background: "#C70541", color: "#FFF", message: '系统繁忙，请稍后重试！' });
              }
              this.submitLoading = false
            });
          }
          else {
            this.submitLoading = false;
            this.form.password = '';
            this.form.captcha = '';
            this.getCaptcha();
            Notify({
              background: "#C70541",
              color: "#FFF",
              message: res.data.msg
            });
          }
        }).catch((err) => {
          Notify({
            background: "#C70541",
            color: "#FFF",
            message: '登录失败！'
          });
        })
      }).catch(() => {

      })
    }
  }
}
</script>

<style scoped>
#login_btn {
  width: 100%;
  height: 45px;
  text-align: center;
  color: white;
  font-weight: 700;
  line-height: 45px;
  background-color: #16253E;
  padding: 1px;
  margin-bottom: 10px;
  border-radius: 8px;
  border: 1px solid #16253E;
}

#rocketIcon {
  /*transform: rotate(45deg);*/
  animation: rocketAni 1.3s ease-in-out 2.7s infinite alternate;
}

@keyframes rocketAni {
  from {
    transform: translate(0, 0);
  }

  to {
    transform: translate(0, 6px);
  }
}
</style>
